export default __webpack_public_path__ + "static/media/icon_cat_BandsWithStones.ec97588d.png";